import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { V2ButtonComponent, V2CardComponent, V2DialogModule } from '@coin/shared/core/ui-storybook';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'customer-guest-access-dialog',
  templateUrl: './guest-access-dialog.component.html',
  styleUrl: './guest-access-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIcon, V2DialogModule, TranslateModule, V2ButtonComponent, V2CardComponent]
})
export class GuestAccessDialogComponent {
  private dialogRef = inject<MatDialogRef<GuestAccessDialogComponent>>(MatDialogRef);

  static openDialog(dialog: MatDialog): MatDialogRef<GuestAccessDialogComponent> {
    return dialog.open(GuestAccessDialogComponent, {
      disableClose: true
    });
  }

  close(): void {
    this.dialogRef.close();
  }
}
